import cn from 'classnames';

import styles from './styles.module.scss';

export interface StepChip {
  id: string;
  label: string;
  /** Короткая сводка выбранных значений — показывается под названием шага */
  summary?: string;
  /** Шаг нельзя открыть: не подходит для выбранного вида транспорта */
  disabled?: boolean;
}

interface StepChipsProps {
  steps: StepChip[];
  activeId: string;
  onSelect: (id: string) => void;
  className?: string;
}

/**
 * Строка чипов-шагов формы: активный — жёлтый, пройденный — светло-синий
 * с подписью выбранных значений, недоступный — серый.
 * На узких экранах скроллится по горизонтали.
 */
const StepChips = ({ steps, activeId, onSelect, className }: StepChipsProps) => (
  <div className={cn(styles.wrapper, className)} role="tablist">
    {steps.map((step) => {
      const isActive = step.id === activeId;

      return (
        <button
          key={step.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          disabled={step.disabled}
          className={cn(styles.chip, {
            [styles.chipActive]: isActive,
            [styles.chipFilled]: !isActive && Boolean(step.summary),
            [styles.chipDisabled]: step.disabled,
          })}
          onClick={() => onSelect(step.id)}
        >
          <span className={styles.chipLabel}>{step.label}</span>
          {!isActive && step.summary && (
            <span className={styles.chipSummary}>{step.summary}</span>
          )}
        </button>
      );
    })}
  </div>
);

export default StepChips;
